module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3bCqBK/tc-custom/9781611520323.jpg?1723592038590",
      "alt": "This image is the cover for the book Runes of the Quest"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Runes of the Quest\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("As a child, Morlea's handmaid wove wondrous tales to amuse her. Among these stories was the legend of Talitha, a princess like Morlea herself, trapped in a tower whose walls wept at her unjust imprisonment. An evil wizard hid her away until a prince could save her, then struck the land and its people barren to prevent any attempt at rescue."), _c('br'), _c('br'), _vm._v("Morlea believes the story nothing more than a fantasy until, years later, she discovers a possible location for the fabled tower. Dissatisfied with palace life and looking for adventure, she decides to chase down Talitha on her own."), _c('br'), _c('br'), _vm._v("A princess needs to be rescued, of course. And if there aren't any able-bodied princes up to the task, why can't another princess be the savior for once?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.T. Marie\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0